"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Attachment = _interopRequireDefault(require("./Attachment"));

var _utils = require("./utils");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var AttachmentList = function AttachmentList(_ref) {
  var _ref$attachments = _ref.attachments,
      attachments = _ref$attachments === void 0 ? [] : _ref$attachments,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      _onDelete = _ref.onDelete,
      onDismissError = _ref.onDismissError;

  if (!attachments.length && !errors.length) {
    return null;
  }

  attachments = (0, _utils.normalizeAttachments)(attachments);
  return (0, _preact.h)("div", {
    className: "content-attachments"
  }, Boolean(errors.length) && (0, _preact.h)("p", {
    className: "content-attachments__error"
  }, (0, _preact.h)("span", null, errors.map(function (_ref2) {
    var filename = _ref2.filename,
        errorPhrase = _ref2.errorPhrase;
    return (0, _preact.h)("span", {
      key: filename
    }, filename, ": ", (0, _preact.h)(_phrase.default, {
      m: "Common",
      p: errorPhrase,
      count: _utils.allowedFilesError
    }), (0, _preact.h)("br", null));
  })), (0, _preact.h)(_Close.default, {
    width: 18,
    height: 18,
    className: "content-attachments__error-close",
    onClick: onDismissError
  })), Boolean(attachments.length) && (0, _preact.h)("div", null, (0, _preact.h)("p", {
    className: "content-attachments__counter"
  }, (0, _preact.h)("strong", null, attachments.length, " Attachments")), (0, _preact.h)("ul", {
    className: "content-attachments-list"
  }, attachments.map(function (_ref3, index) {
    var filename = _ref3.filename,
        url = _ref3.url;
    return (0, _preact.h)(_Attachment.default, {
      filename: filename,
      url: url,
      onDelete: function onDelete() {
        return _onDelete(index);
      },
      key: index
    });
  }))));
};

var _default = AttachmentList;
exports.default = _default;